import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';

const ScriptureDataSection: FC = () => {
  const { t } = useTranslate();
  const { data } = useEncumbranceDetailsPage();

  const scriptureData = data?.scriptureData;
  // const scriptureDocument = data?.scriptureDocument;

  return (
    <div className="encumbrance-details__card">
      <p className="encumbrance-details__card-title">{t('ScriptureData')}</p>

      <dl className="encumbrance-details__meta">
        <dt>{t('NotaryName')}</dt>
        <dd>{scriptureData?.notaryName || '-'}</dd>

        <dt>{t('NotaryProtocolNumber')}</dt>
        <dd>{scriptureData?.protocolNr || '-'}</dd>

        <dt>{t('NotaryCity')}</dt>
        <dd>{scriptureData?.notaryCity || '-'}</dd>
      </dl>

      {/* {scriptureDocument && (
        <div className="encumbrance-details__document">
          <i className="ti ti-file-text" aria-hidden="true" />
          <span className="encumbrance-details__document-name">
            {scriptureDocument.name}
          </span>
          <button
            type="button"
            className="encumbrance-details__document-action"
            onClick={() => {

            }}
          >
            {t('View')}
          </button>
        </div>
      )} */}
    </div>
  );
};

export default ScriptureDataSection;
